import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  searchPurchaseOrders,
  setSearchBy,
} from '../../state/purchaseOrderBrowseSlice';
import { useDispatch, useSelector } from '../../state';
import type { PurchaseOrderSearchInput } from '@repo/api-contract';
import { useTranslation } from 'react-i18next';

export default function BasicSelect() {
  const dispatch = useDispatch();
  const { t: tGC } = useTranslation([], { keyPrefix: 'team.Global.Common' });
  const { t: tGT } = useTranslation([], { keyPrefix: 'team.Global.Tables' });
  const { t: tCO } = useTranslation([], {
    keyPrefix: 'team.Components.PurchaseOrderBrowseTable',
  });

  const { searchInput, searchBy } = useSelector(
    (store) => store.purchaseOrderBrowseSlice,
  );

  const handleChange = (event: SelectChangeEvent) => {
    const searchValue = event.target
      .value as PurchaseOrderSearchInput['searchBy'];
    dispatch(setSearchBy(searchValue));
    const payload: PurchaseOrderSearchInput = {
      query: searchInput,
      searchBy: searchValue,
      size: 100,
      page: 0,
    };
    dispatch(searchPurchaseOrders(payload));
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">
          {tGT('Search By')}
        </InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={searchBy}
          label={tGT('Search By')}
          onChange={handleChange}
        >
          <MenuItem value={'orderCode'}>{tGC('Purchase Order No.')}</MenuItem>
          <MenuItem value={'vendorName'}>{tCO('Vendor Name')}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
